import { get, post } from './api';
import type { AuthUser } from '@/store/auth.store';

export type LoginResponse = {
  access_token: string;
  refresh_token: string;
  user: AuthUser;
};

export type RequestCodeResponse = {
  sentAt: string;
  nextAt: string;
};

// Шаг 1: запрашиваем код на email владельца.
export function requestLoginCode(email: string) {
  return post<RequestCodeResponse>('/api/public/auth/request', { email });
}

// Шаг 2: подтверждаем код, получаем JWT-пару + user.
export function verifyLoginCode(email: string, code: string) {
  return post<LoginResponse>('/api/public/auth/verify', { email, code });
}

export function getMe() {
  return get<{ user: AuthUser }>('/api/auth/me');
}

export function refreshToken(refresh_token: string) {
  return post<{ access_token: string }>('/api/auth/refresh', { refresh_token });
}

// SSO-handoff из ЛК лендинга: одноразовый nonce → JWT-пара.
export function ssoExchange(nonce: string) {
  return post<LoginResponse>('/api/auth/sso/exchange', { nonce });
}
